import { styled } from "@linaria/react";
import { ReactNode, KeyboardEvent, ComponentProps, MouseEvent } from "react";
import { BORDER_RADIUS_DEFAULT, COLOR_GRAY_DARK, COLOR_GRAY_LIGHTER, COLOR_WHITE } from "../../constants";
import { useCookieValue } from "../../utils"; // eslint-disable-next-line @typescript-eslint/no-var-requires

const CloseIcon = require("./close.svg");

const Container = /*#__PURE__*/styled("div")({
  name: "Container",
  class: "cpcmoqt"
});
const Close = /*#__PURE__*/styled("button")({
  name: "Close",
  class: "c1bk5utz"
});
const HIDE_VALUE = "hide";

function PromotionBanner({
  children,
  cookieProperty = "promotion",
  onClick
}: {
  children: ReactNode;
  cookieProperty?: string;
} & Pick<ComponentProps<typeof Container>, "onClick">): JSX.Element {
  const {
    setValue: setCookieValue,
    value
  } = useCookieValue(cookieProperty);
  const shown = value === HIDE_VALUE;

  const hide = () => {
    setCookieValue(HIDE_VALUE);
  };

  const onKeyDown = (event: KeyboardEvent<HTMLElement>) => {
    if (event.key === " " || event.key === "Enter") {
      event.preventDefault();
      hide();
    }
  };

  return <>
      {shown && <Container onClick={onClick}>
          {children}
          <Close onClick={(event: MouseEvent<HTMLElement>) => {
        event.stopPropagation();
        hide();
      }} onKeyDown={onKeyDown}>
            <CloseIcon alt="close" />
          </Close>
        </Container>}
    </>;
}

export default PromotionBanner;

require("../../../.linaria-cache/src/components/promotionBanner/index.linaria.module.css");